import { Component, Inject, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavListItem } from '../../navigation.component';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-expandable-nav-list',
  templateUrl: './expandable-nav-list.component.html',
})
export class ExpandableNavListComponent implements OnInit {
  @Input() route: string;
  @Input() navItems: NavListItem[];

  menuItems: NavListItem[] = [];
  dashboardItems: NavListItem[] = [];
  accountItems: NavListItem[] = [];
  resourceItems: NavListItem[] = [];
  mainItems: NavListItem[] = [];
  controlItems: NavListItem[] = [];

  subs: Subscription[] = [];

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<ExpandableNavListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.navItems = this.data.navList;
  }

  ngOnInit() {
    this.navItems.forEach((item) => {
      const assignToSection = (navItem) => {
        if (navItem.section === 'menu') {
          this.menuItems.push(navItem);
        } else if (navItem.section === 'dashboard') {
          this.dashboardItems.push(navItem);
        } else if (navItem.section === 'account') {
          this.accountItems.push(navItem);
        } else if (navItem.section === 'resources') {
          this.resourceItems.push(navItem);
        } else if (navItem.section === 'main') {
          this.mainItems.push(navItem);
        } else if (navItem.section === 'control') {
          this.controlItems.push(navItem);
        }
      };

      if (!item.condition || item.condition()) {
        assignToSection(item);

        if (item.children && Array.isArray(item.children)) {
          item.children.forEach((child) => {
            if (!child.condition || child.condition()) {
              assignToSection(child);
            }
          });
        }
      }
    });
  }

  handleAction(item: NavListItem): void {
    if (item.action) {
      item.action();
      this.closeDialog();
    }
  }

  hasMenuSection(): boolean {
    return this.navItems.some(
      (i) => i.section === 'menu' && (!i.condition || i.condition()),
    );
  }

  hasAccountSection(): boolean {
    return this.navItems.some(
      (i) => i.section === 'account' && (!i.condition || i.condition()),
    );
  }

  hasResourcesSection(): boolean {
    return this.navItems.some(
      (i) => i.section === 'resources' && (!i.condition || i.condition()),
    );
  }

  iconIsAsset(iconString) {
    return iconString.includes('/');
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
